import { t } from "@lingui/macro"
import {
    DescriptionRounded,
    PushPinRounded,
    LibraryBooksRounded,
} from "@mui/icons-material"
import { Stack, useTheme, Tooltip } from "@mui/material"
import { useMemo } from "react"

import {
    CardContainer,
    HeaderContainer,
    IconWrapper,
    InfoIcon,
    SubtitleTypography,
    TitleTypography,
} from "./styled"

import { IKnowledgeBaseItemCardProps } from "./types"

import { Icon } from "src/components/icons"

import { EKnowledgeBaseCardSection } from "src/views/knowledge-base/pages/home/types"

export const KnowledgeBaseItemCard = ({
    cardType,
    title,
    totalItems,
    onClick,
}: IKnowledgeBaseItemCardProps) => {
    const theme = useTheme()

    const getIcon = useMemo(() => {
        switch (cardType) {
            case EKnowledgeBaseCardSection.Documents:
                return <DescriptionRounded />
            case EKnowledgeBaseCardSection.NoticeBoard:
                return <PushPinRounded />
            case EKnowledgeBaseCardSection.Library:
                return <LibraryBooksRounded />
            default:
                return <DescriptionRounded />
        }
    }, [cardType])

    const shouldShowInfoIcon = useMemo(() => {
        return (
            cardType === EKnowledgeBaseCardSection.NoticeBoard ||
            cardType === EKnowledgeBaseCardSection.Library
        )
    }, [cardType])

    const getTooltipText = useMemo(() => {
        switch (cardType) {
            case EKnowledgeBaseCardSection.NoticeBoard:
                return t`knowledge-base-card.notice-board-info`
            case EKnowledgeBaseCardSection.Library:
                return t`knowledge-base-card.library-info`
            default:
                return ""
        }
    }, [cardType])

    return (
        <CardContainer onClick={onClick}>
            <HeaderContainer>
                <IconWrapper>
                    <Icon icon={getIcon} color={theme.palette.grey[600]} />
                </IconWrapper>
                {shouldShowInfoIcon && (
                    <Tooltip title={getTooltipText} placement="top">
                        <InfoIcon />
                    </Tooltip>
                )}
            </HeaderContainer>
            <Stack spacing={1}>
                <TitleTypography variant="subtitle1">{title}</TitleTypography>
                <SubtitleTypography variant="body2">
                    {`${t`knowledge-base-item-card.no-of-resources`}: ${
                        totalItems ?? 0
                    }`}
                </SubtitleTypography>
            </Stack>
        </CardContainer>
    )
}
